module.exports = __webpack_public_path__ + "style/img/万和新logo组合（让家更温暖） 1.edbec10c.png";